import { ModelBase } from "../abstract/model-base.model";

/** Déclencheur d'un axe : racine de compte + caractère obligatoire. */
export interface AnalyticalTrigger {
    root: string;
    mandatory: boolean;
}

export class AnalyticalAxis extends ModelBase {

    static override CLASS_NAME: string = 'AnalyticalAxis';

    private _active!: boolean;
    private _allowMultiSection!: boolean;
    private _code!: string;
    private _label!: string;
    private _triggers!: AnalyticalTrigger[];

    public override toString(): string {
        return this._label;
    }

    public get active(): boolean {
        return this._active;
    }

    public set active(value: any) {
        this._setValue('_active', value, 'boolean');
    }

    public get allowMultiSection(): boolean {
        return this._allowMultiSection;
    }

    public set allowMultiSection(value: any) {
        this._setValue('_allowMultiSection', value, 'boolean');
    }

    public get code(): string {
        return this._code;
    }

    public set code(value: any) {
        this._setValue('_code', value, 'string');
    }

    public get label(): string {
        return this._label;
    }

    public set label(value: any) {
        this._setValue('_label', value, 'string');
    }

    public get triggers(): AnalyticalTrigger[] {
        return this._triggers;
    }

    public set triggers(value: any) {
        this._setValue('_triggers', value, 'json');
    }
}
